import { render, staticRenderFns } from "./Mappa.vue?vue&type=template&id=22358eac&scoped=true&lang=pug&"
import script from "./Mappa.vue?vue&type=script&lang=ts&"
export * from "./Mappa.vue?vue&type=script&lang=ts&"
import style0 from "./Mappa.vue?vue&type=style&index=0&id=22358eac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22358eac",
  null
  
)

export default component.exports